import FbButton from 'components/FbUI/FbButton'
import styled from 'styled-components'

export const SaveButton = styled(FbButton)`
  margin-left: auto;
  margin-top: 10px;
  align-self: flex-end;
`
